/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { useTheme, withTheme } from '@shared/lib';
interface LinkComponentProps {
  label: string;
  url: string;
}
export const LinkComponent: FC<LinkComponentProps> = ({
  label,
  url
}) => {
  const router = useRouter();
  const theme = useTheme();
  const isPayQRPage = router.asPath.includes('pay-qr');
  const isPubgGiveawayPage = router.asPath.includes('rozygrysh-prizov-pubg-mobile');
  const isVesenniiRozygryshPage = router.asPath.includes('vesennii-rozygrysh-prizov-2026');
  const isGenshinPubgResultsPage = router.asPath.includes('rozygrysh-prizov-genshin-pubg-itogi');
  const isDvoinoiShansNaPobeduPage = router.asPath.includes('dvoinoi-shans-na-pobedu');
  const isOsenniiRozygryshPrizov2026Page = router.asPath.includes('osennii-rozygrysh-prizov-2026');
  return <Link passHref href={url}>
      <WrapperLabel>
        <WrapperIcon>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4773_16847)">
              <path d="M4.65386 4.65581C4.14317 5.1665 4.10531 5.67529 4.02958 6.69287C4.00994 6.95665 3.99805 7.22875 3.99805 7.50085C3.99805 7.77296 4.00994 8.04506 4.02958 8.30884C4.10531 9.32642 4.14317 9.83521 4.65386 10.3459C5.16455 10.8566 5.67334 10.8944 6.69091 10.9702C6.95469 10.9898 7.2268 11.0017 7.4989 11.0017C7.771 11.0017 8.04311 10.9898 8.30689 10.9702C9.32447 10.8944 9.83326 10.8566 10.3439 10.3459C10.8546 9.83521 10.8925 9.32642 10.9682 8.30884C10.9879 8.04506 10.9998 7.77296 10.9998 7.50085C10.9998 7.22875 10.9879 6.95665 10.9682 6.69287C10.8925 5.67529 10.8546 5.1665 10.3439 4.65581C9.83326 4.14513 9.32447 4.10726 8.30689 4.03153C8.04311 4.0119 7.771 4 7.4989 4C7.2268 4 6.95469 4.0119 6.69091 4.03153C5.67334 4.10726 5.16455 4.14513 4.65386 4.65581Z" fill={isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isVesenniiRozygryshPage ? '#EBF1FD' : isGenshinPubgResultsPage ? '#FAFAFA' : isDvoinoiShansNaPobeduPage ? '#EBF1FD' : isOsenniiRozygryshPrizov2026Page ? '#adb0cc' : theme.colors.icon.tertiary} />
              <path d="M13.6558 4.65581C13.1451 5.1665 13.1073 5.67529 13.0315 6.69287C13.0119 6.95665 13 7.22875 13 7.50085C13 7.77296 13.0119 8.04506 13.0315 8.30884C13.1073 9.32642 13.1451 9.83521 13.6558 10.3459C14.1665 10.8566 14.6753 10.8944 15.6929 10.9702C15.9566 10.9898 16.2288 11.0017 16.5009 11.0017C16.773 11.0017 17.0451 10.9898 17.3088 10.9702C18.3264 10.8944 18.8352 10.8566 19.3459 10.3459C19.8566 9.83521 19.8944 9.32642 19.9702 8.30884C19.9898 8.04506 20.0017 7.77296 20.0017 7.50085C20.0017 7.22875 19.9898 6.95665 19.9702 6.69287C19.8944 5.67529 19.8566 5.1665 19.3459 4.65581C18.8352 4.14513 18.3264 4.10726 17.3088 4.03153C17.0451 4.0119 16.773 4 16.5009 4C16.2288 4 15.9566 4.0119 15.6929 4.03153C14.6753 4.10726 14.1665 4.14513 13.6558 4.65581Z" fill={isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isVesenniiRozygryshPage ? '#EBF1FD' : isGenshinPubgResultsPage ? '#FAFAFA' : isDvoinoiShansNaPobeduPage ? '#EBF1FD' : isOsenniiRozygryshPrizov2026Page ? '#adb0cc' : theme.colors.icon.tertiary} />
              <path d="M13.0315 15.6922C13.1072 14.6749 13.1451 14.1662 13.6557 13.6557C14.1662 13.1451 14.6749 13.1072 15.6922 13.0315C15.9559 13.0119 16.228 13 16.5 13C16.772 13 17.0441 13.0119 17.3078 13.0315C18.3251 13.1072 18.8338 13.1451 19.3443 13.6557C19.8549 14.1662 19.8928 14.6749 19.9685 15.6922C19.9881 15.9559 20 16.228 20 16.5C20 16.772 19.9881 17.0441 19.9685 17.3078C19.8928 18.3251 19.8549 18.8338 19.3443 19.3443C18.8338 19.8549 18.3251 19.8928 17.3078 19.9685C17.0441 19.9881 16.772 20 16.5 20C16.228 20 15.9559 19.9881 15.6922 19.9685C14.6749 19.8928 14.1662 19.8549 13.6557 19.3443C13.1451 18.8338 13.1072 18.3251 13.0315 17.3078C13.0119 17.0441 13 16.772 13 16.5C13 16.228 13.0119 15.9559 13.0315 15.6922Z" fill={isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isVesenniiRozygryshPage ? '#EBF1FD' : isGenshinPubgResultsPage ? '#FAFAFA' : isDvoinoiShansNaPobeduPage ? '#EBF1FD' : isOsenniiRozygryshPrizov2026Page ? '#adb0cc' : theme.colors.icon.tertiary} />
              <path d="M4.65568 13.6557C4.1451 14.1663 4.10724 14.6749 4.03152 15.6923C4.01189 15.956 4 16.2281 4 16.5001C4 16.7722 4.01189 17.0442 4.03152 17.3079C4.10724 18.3253 4.1451 18.834 4.65568 19.3446C5.16626 19.8551 5.67494 19.893 6.6923 19.9687C6.95603 19.9883 7.22808 20.0002 7.50012 20.0002C7.77217 20.0002 8.04422 19.9883 8.30794 19.9687C9.32531 19.893 9.83399 19.8551 10.3446 19.3446C10.8551 18.834 10.893 18.3253 10.9687 17.3079C10.9884 17.0442 11.0002 16.7722 11.0002 16.5001C11.0002 16.2281 10.9884 15.956 10.9687 15.6923C10.893 14.6749 10.8551 14.1663 10.3446 13.6557C9.83399 13.1451 9.32531 13.1072 8.30794 13.0315C8.04422 13.0119 7.77217 13 7.50012 13C7.22808 13 6.95603 13.0119 6.6923 13.0315C5.67494 13.1072 5.16626 13.1451 4.65568 13.6557Z" fill={isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isVesenniiRozygryshPage ? '#EBF1FD' : isGenshinPubgResultsPage ? '#FAFAFA' : isDvoinoiShansNaPobeduPage ? '#EBF1FD' : isOsenniiRozygryshPrizov2026Page ? '#adb0cc' : theme.colors.icon.tertiary} />
            </g>
            <defs>
              <clipPath id="clip0_4773_16847">
                <rect width="24" height="24" fill={theme.colors.icon.white} />
              </clipPath>
            </defs>
          </svg>
        </WrapperIcon>
        <Text isPayQRPage={isPayQRPage} isPubgGiveawayPage={isPubgGiveawayPage} isVesenniiRozygryshPage={isVesenniiRozygryshPage} isGenshinPubgResultsPage={isGenshinPubgResultsPage} isDvoinoiShansNaPobeduPage={isDvoinoiShansNaPobeduPage} isOsenniiRozygryshPrizov2026Page={isOsenniiRozygryshPrizov2026Page}>
          {label}
        </Text>
      </WrapperLabel>
    </Link>;
};
interface TextProps {
  isPayQRPage: boolean;
  isPubgGiveawayPage: boolean;
  isVesenniiRozygryshPage: boolean;
  isGenshinPubgResultsPage: boolean;
  isDvoinoiShansNaPobeduPage: boolean;
  isOsenniiRozygryshPrizov2026Page: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage,
  isVesenniiRozygryshPage,
  isGenshinPubgResultsPage,
  isDvoinoiShansNaPobeduPage,
  isOsenniiRozygryshPrizov2026Page,
  theme
}) => isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isVesenniiRozygryshPage ? '#EBF1FD' : isGenshinPubgResultsPage ? '#FAFAFA' : isDvoinoiShansNaPobeduPage ? '#EBF1FD' : isOsenniiRozygryshPrizov2026Page ? '#adb0cc' : theme.colors.text.tertiary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "txxk8pg",
  propsAsIs: false,
  vars: {
    "txxk8pg-0": [_exp()],
    "txxk8pg-1": [_exp2()],
    "txxk8pg-2": [_exp3(), "px"],
    "txxk8pg-3": [_exp4()]
  }
}));
const WrapperIcon = /*#__PURE__*/styled('div')({
  name: "WrapperIcon",
  class: "w1oocrpl",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperLabel = withTheme(/*#__PURE__*/styled('li')({
  name: "WrapperLabel",
  class: "w1mgo6l3",
  propsAsIs: false,
  vars: {
    "w1mgo6l3-0": [_exp5()],
    "w1mgo6l3-1": [_exp6()]
  }
}));

require("./LinkComponent.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./LinkComponent.tsx");